module.exports = __webpack_public_path__ + "img/female_B_01.2540f1e6.png";